import { Button } from '@/Atomic/Molecules/Button'

import './TabEmptyState.scss'

interface TabEmptyStateCta {
  label: string
  icon?: string
  onClick: () => void
}

interface TabEmptyStateProps {
  title: string
  description?: string
  cta?: TabEmptyStateCta
}

export const TabEmptyState: React.FC<TabEmptyStateProps> = ({
  title,
  description,
  cta,
}) => (
  <div className="tab-empty-state">
    <h3 className="tab-empty-state-title">{title}</h3>
    {description && (
      <p className="tab-empty-state-description">{description}</p>
    )}
    {cta && (
      <Button variant="outlined" icon={cta.icon} onClick={cta.onClick}>
        {cta.label}
      </Button>
    )}
  </div>
)
